<!-- =========================================================================================
  File Name: PurchaseList.vue
  Description: Purchase List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vaagai Tecknowledge - Easy Admin
  Author: Web Team
  Author URL: http://www.vaagai.org.in/
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">

    <h4> {{ $t("PurchasePageDescription") }} </h4>

    <iframe id="printPdf" name="printPdf"></iframe>

    <!-- <price-group-add-new :addRecordPrompt="addRecordPrompt" @hideAddRecordPrompt="hideAddRecordPrompt" v-if="addRecordPrompt"></price-group-add-new>

    <price-group-edit :editRecordPrompt="editRecordPrompt" @hideEditRecordPrompt="hideEditRecordPrompt" v-if="editRecordPrompt" :recordIndex="recordToEdit" ></price-group-edit> -->

    <vs-popup fullscreen title="Purchase Invoice Details" :active.sync="viewProductsPrompt">
      <purchase-products-view :recordIndex="recordToEdit" :viewProductsPrompt="viewProductsPrompt" v-if="viewProductsPrompt" ></purchase-products-view>
    </vs-popup>    

    <fab :actions="btnActions" @addbtn="addData()" @editbtn="editAlert(selected)" @pdfbtn="genPdfAlert(selected)" @viewbtn="viewProductsAlert(selected)" @deletebtn="deleteAlert(selected)" :position="btnPosition" :start-opened="btnOpened" :main-icon="btnIcon" :toggle-when-away="btnToggle" :main-tooltip="btnTooltp" :fixed-tooltip="fixedTooltip" :ripple-show="btnShow" :ripple-color="btnColor" :icon-size="btnSize" ></fab>

    <!-- <p class="text-danger">{{ message }}</p>
    <h4 class="text-success text-center">{{ successTxt }}</h4>
    <h4 class="text-danger text-center">{{ errorTxt }}</h4> -->
    
    <vs-table ref="table" v-model="selected" pagination :max-items="itemsPerPage" search :data="rows">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center">

          <!-- ACTION - DROPDOWN -->
          <!-- <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">

            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32">
              <span class="mr-2">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item>
                <span>Delete</span>
              </vs-dropdown-item>
              <vs-dropdown-item>
                <span>Archive</span>
              </vs-dropdown-item>
              <vs-dropdown-item>
                <span>Print</span>
              </vs-dropdown-item>
              <vs-dropdown-item>
                <span>Another Action</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown> -->

          <!-- ADD NEW -->

        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ rows.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : rows.length }} of {{ rows.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="sno"> # </vs-th>
        <vs-th sort-key="Taxable"> {{ $t("Type") }} </vs-th>
        <vs-th sort-key="PurchaseInvoiceDateTxt"> {{ $t("Date") }} </vs-th>
        <vs-th sort-key="PurchaseInvoiceNumber"> {{ $t("InvoiceNumber") }} </vs-th>
        <vs-th sort-key="PartyName"> {{ $t("SupplierName") }} </vs-th>
        <vs-th sort-key="Address"> {{ $t("Address") }} </vs-th>
        <vs-th sort-key="TotalAmount"> {{ $t("Amount") }} </vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data"  :state="tr.Taxable == 1 ? null : 'dark'">

              <vs-td>
                {{ tr.sno }}
              </vs-td>

                <vs-td>
                    {{ tr.Taxable }}
                </vs-td>              

                <vs-td>
                    <!-- <vs-chip :color="getActiveStatusColor(tr.ActiveStatus)">
                        {{ tr.ActiveStatus }}
                    </vs-chip> -->
                    {{ tr.PurchaseInvoiceDateTxt }}
                </vs-td>

                <vs-td>
                    {{ tr.PurchaseInvoiceNumber }}
                </vs-td>

                <vs-td>
                    {{ tr.PartyName }}
                </vs-td>

                <vs-td>
                    {{ tr.Address }}, {{ tr.CityName }}, {{ tr.DistrictName }}, {{ tr.PartyStatesName }}
                </vs-td>

                <vs-td>
                    {{ tr.TotalAmount }}
                </vs-td>

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
  </div>
</template>

<script>

import companyConfig from '@/company_config.json'
import common from '@/views/Common.vue'
import PurchaseProductsView from "./PurchaseProductsView.vue"
import fab from 'vue-fab'

var successTxt = '';
var errorTxt = '';
/*
const username=this.$session.get('username');
const role=this.$session.get('role');
const token=this.$session.get('token');
*/
export default {
  mixins: [common],
  components: {
    fab,
    PurchaseProductsView
  },
  data() {
    // console.log('username='+username+', role='+role+', token'+token);
    return {
      btnPosition: 'bottom-right',
      btnOpened: false,
      btnIcon: 'more',
      btnToggle: true,
      btnTooltp: 'More Actions',
      fixedTooltip: false,
      btnShow: true,
      btnColor: 'light',
      btnSize: 'medium',
      switch2: true,
      btnActions: [],
      activeConfirm: false,
      selected: [],
      // rows: [],
      itemsPerPage: 10,
      isMounted: false,
      message: '',
      successTxt,
      errorTxt,
      addRecordPrompt: false,
      hideAddRecordPrompt: true,
      editRecordPrompt: false,
      hideEditRecordPrompt: true,
      viewProductsPrompt: false,

      recordToEdit: "",
      getAllRecords: {},
      record: {},

      PurchaseInvoice:[],
    }
  },
  computed: {
    currentPage() {
      if(this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    
    rows() {
      return this.$store.getters['purchase/dataList'];
    },
    
  },
  methods: {
    backPage() {
      this.$router.go(-1);
    },
    getOrderStatusColor(status) {
      if(status == 'on hold') return "warning"
      if(status == 'Active') return "success"
      if(status == 'Inactive') return "danger"
      return "primary"
    },
    addData(){
      var params = {};
      var url = '/purchase/create';
      this.pageRedirect(params, url);
    },

    editAlert(tr) {

      console.log('tr='+tr);
      var n = Object.keys(tr).length;
      console.log('n='+n);
      if (n > 0) {

        var id=tr.PurchaseInvoiceId;
        var details=tr.PartyName;
        console.log('id='+id+', details='+details);

        var alert_title='Edit Purchase Invoice details';
        var alert_text='Do you want to edit '+details+' Purchase Invoice details?';

        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: alert_title,
          text: alert_text,
          accept: this.editData
        });
        // this.deleteRecords(where, url, destination, list_url);
        
      } else {
        var output = 'Kindly select record to edit';
        this.errorMessage(output);
      }
      
    },
    
    editData(){
      var selected = this.selected;
      var n = Object.keys(selected).length;
      var id=selected.PurchaseInvoiceId;
      // var id=selected.sno - 1;
      var index = this.rows.map(e => e.PurchaseInvoiceId).indexOf(id);
      console.log('n='+n);
      console.log('id='+id+', index='+index+', record='+JSON.stringify(this.rows[index]));
      if (id >= 0) {
        this.recordToEdit= index;
        this.editRecordPrompt = true;
      }
    },

    viewProductsAlert(tr) {

      console.log('tr='+tr);
      var n = Object.keys(tr).length;
      console.log('n='+n);
      if (n > 0) {

        var id=tr.PurchaseInvoiceId;
        var details=tr.PartyName;
        console.log('id='+id+', details='+details);

        var alert_title='View Purchase Invoice details';
        var alert_text='Do you want to view '+details+' Purchase Invoice details?';

        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: alert_title,
          text: alert_text,
          accept: this.viewProductsData
        });
        // this.deleteRecords(where, url, destination, list_url);
        
      } else {
        var output = 'Kindly select record to view Purchase Invoice';
        this.errorMessage(output);
      }
      
    },
    
    viewProductsData(){
      var selected = this.selected;
      var n = Object.keys(selected).length;
      var id=selected.PurchaseInvoiceId;
      // var id=selected.sno - 1;
      var index = this.rows.map(e => e.PurchaseInvoiceId).indexOf(id);
      console.log('n='+n);
      console.log('id='+id+', index='+index+', record='+JSON.stringify(this.rows[index]));
      if (id >= 0) {
        this.recordToEdit= index;
        this.viewProductsPrompt = true;
      }
    },

    genPdfAlert(tr) {

      console.log('tr='+tr);
      var n = Object.keys(tr).length;
      console.log('n='+n);
      if (n > 0) {

        var id=tr.PurchaseInvoiceId;
        var details=tr.PartyName;
        console.log('id='+id+', details='+details);

        var alert_title='Generate PDF';
        var alert_text='Do you want to generate '+details+' Purchase Invoice details as PDF?';

        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: alert_title,
          text: alert_text,
          accept: this.genPdfData
        });
        // this.deleteRecords(where, url, destination, list_url);
        
      } else {
        var output = 'Kindly select record to generate PDF';
        this.errorMessage(output);
      }
      
    },
    purchaseInvoicePDF(){

      var defaultStyle={ // change the default styles
        a:{ // for <A>
          color:'purple', // all links should be 'purple'
          decoration:'' // remove underline
        },
        li:'' // remove all default styles for <LI>
      };      

      var htmlToPdfmake = require("html-to-pdfmake");
      var content = {};
      content = htmlToPdfmake(`
        <div>
          <h1>My title</h1>
          <p>
            This is a sentence with a <strong>bold word</strong>, <em>one in italic</em>,
            and <u>one with underline</u>. And finally <a href="https://www.somewhere.com">a link</a>.
          </p>
        </div>
        `, {
        defaultStyles:defaultStyle
      });
      var styles={
        'html-strong':{
          background:'yellow' // it will add a yellow background to all <STRONG> elements
        }
      };
      var filename='test';
      var pdfType=4;
      var windowType=1;
      var docDefinition = {
        content: content,
        styles: styles,
      };
      this.generatePDF(filename, pdfType, windowType, docDefinition);

    },    
    genPdfData(){
      var selected = this.selected;
      var n = Object.keys(selected).length;
      var id=selected.PurchaseInvoiceId;
      // var id=selected.sno - 1;
      var index = this.rows.map(e => e.PurchaseInvoiceId).indexOf(id);
      console.log('n='+n);
      console.log('id='+id+', index='+index+', record='+JSON.stringify(this.rows[index]));
      if (id >= 0) {
        /*
        var SgstFlag = this.rows[index].IntraState;
        var CessFlag = this.rows[index].CessFlag;
        */
        var Taxable = this.rows[index].Taxable;
        var InvoiceDate = this.rows[index].PurchaseInvoiceDateTxt;
        var InvoiceNumber = this.rows[index].PurchaseInvoiceNumber;
        var Description = this.rows[index].Description;
        var PartyDetails = this.rows[index].PartyDetails;
        var Products = this.rows[index].Products;
        var InvoiceSubTotal = this.rows[index].SubTotal;
        var Sgst = this.rows[index].sgst;
        var Cgst = this.rows[index].cgst;
        var Igst = this.rows[index].igst;
        var Cess = this.rows[index].Cess;
        var RoundOff = this.rows[index].RoundOff;
        var InvoiceTotal = this.rows[index].TotalAmount;
        
        var tableHeader = [
          'Product Code', 'Product Name', 'GST', 'Qty', 'Price', 'Sub Total', 'SGST', 'CGST', 'IGST', 'CESS', 'Amount'
        ];

        var tableContent = [];

        tableContent.push(tableHeader);

        for (let index = 0; index < Products.length; index++) {
          var CustomCode = Products[index].CustomCode;
          var ProductName = Products[index].ProductName;
          var GstSlab = Products[index].GstSlab;
          var Qty = Products[index].Qty;
          var Price = Products[index].Price;
          var ProductSubTotal = Products[index].ProductSubTotal;
          var ProductSgst = Products[index].ProductSgst;
          var ProductCgst = Products[index].ProductCgst;
          var ProductIgst = Products[index].ProductIgst;
          var ProductCess = Products[index].ProductCess;
          var ProductTotal = Products[index].ProductTotal;
          
          tableContent.push(
            [ CustomCode, ProductName, GstSlab, Qty, Price, ProductSubTotal, ProductSgst, ProductCgst, ProductIgst, ProductCess, ProductTotal]
          );
          
        }

        tableContent.push(
            [ {text: 'Round Off', colSpan: 5, alignment: 'right'}, '', '', '', '', '', '', '', '', '', RoundOff]
          );

        tableContent.push(
            [ {text: 'Invoice Total', colSpan: 5, alignment: 'right'}, '', '', '', '', InvoiceSubTotal, Sgst, Cgst, Igst, Cess, InvoiceTotal]
          );

        console.log('tableHeader='+JSON.stringify(tableHeader)+'tableContent='+JSON.stringify(tableContent));
        /*
        var content=[
          {
            columns: [
              {
                text: 'Taxable \n\n '+Taxable
              },
              {
                text: 'Invoice Date \n\n '+InvoiceDate
              },
              {
                text: 'Invoice Number \n\n '+InvoiceNumber
              }
            ]
          },
          '\n',
          {
            columns: [
              {
                text: 'Supplier Details \n\n '+PartyDetails
              },
              {
                text: 'Description \n\n '+Description
              },
            ]
          },
          '\n',
          {
            table: {
              body: tableContent
            }
          }
        ];
        */

        var defaultStyle={ // change the default styles
          a:{ // for <A>
            color:'purple', // all links should be 'purple'
            decoration:'' // remove underline
          },
          li:'' // remove all default styles for <LI>
        };      

        var htmlToPdfmake = require("html-to-pdfmake");
        var content = htmlToPdfmake(`
          <table style="width: 100%;" border="0" cellspacing="0" cellpadding="0">
              <tbody>
                  <tr style="height: 64px;">
                      <td style="width: 13.0403%; height: 64px;">
                          <h4>&lt;Company logo here&gt;</h4>
                      </td>
                      <td style="width: 50.9597%; height: 64px;">
                          <p></p>
                          <div style="font-size: 20px;"><strong>Company Name</strong></div>
                          <div style="font-size: 16px;"><strong>State with code<br /> GSTIN: ASDFG<br />PAN No:123456</strong>
                          </div>
                      </td>
                      <td style="width: 32%; height: 64px;">
                          <h4>Invoice Date: `+InvoiceDate+`</h4>
                          <h4>Invoice No.: <br />`+InvoiceNumber+`</h4>
                      </td>
                  </tr>
              </tbody>
          </table>
          <div style="height: 4px; background-color: #000000; text-align: center;"><span
                  style="position: relative; top: -0.5em; background-color: white; padding: 5px; font-size: 20px;">TAX
                  INVOICE</span></div>
          <p>&nbsp;</p>
          <table style="width: 100%;" border="0" cellspacing="0" cellpadding="0">
              <tbody>
                  <tr style="height: 16px;">
                      <td style="width: 20%; height: 20px;">Billed To</td>
                      <td style="width: 28%; height: 20px;">&nbsp;</td>
                      <td style="width: 24%; height: 107px;" rowspan="5">
                          <div style="font-size: 14px;"><b>Billing Address</b><br />Company Name<br /> Company Address<br /> State
                              with code</div>
                      </td>
                      <td style="width: 54%; height: 107px;" rowspan="5">
                          <div style="font-size: 14px;"><b>Delivery Address</b><br />Company Name<br /> Company Address<br />
                              State with code</div>
                      </td>
                  </tr>
                  <tr style="height: 19px;">
                      <td style="width: 20%; height: 28px; font-size: 14px;">Name</td>
                      <td style="width: 28%; height: 28px; font-size: 14px;">: <strong>`+PartyDetails+`</strong></td>
                  </tr>
                  <tr style="height: 28px;">
                      <td style="width: 20%; height: 28px; font-size: 14px;">GSTIN</td>
                      <td style="width: 28%; height: 28px; font-size: 14px;">: <strong>ZXCIEOUREOI</strong></td>
                  </tr>
                  <tr style="height: 23px;">
                      <td style="width: 20%; height: 28px; font-size: 14px;">PAN Number</td>
                      <td style="width: 28%; height: 28px; font-size: 14px;">: <strong>LAIJFEIOJFE</strong></td>
                  </tr>
                  <tr style="height: 21px;">
                      <td style="width: 20%; height: 28px; font-size: 14px;">Place of Supply</td>
                      <td style="width: 28%; height: 28px; font-size: 14px;">: <strong>TAMILNADU (33)</strong></td>
                  </tr>
              </tbody>
          </table>
          <p>&nbsp;</p>
          <table style="width: 100%;" border="1" cellspacing="0" cellpadding="0">
              <tbody>
                  <tr style="height: 3px;">
                      <td style="width: 48.5451%; height: 27px; font-size: 12px;" rowspan="3">Description<br />Invoice description
                          goes here</td>
                      <td style="width: 15.4549%; height: 3px; font-size: 12px;">SO Number</td>
                      <td style="width: 24%; height: 3px; font-size: 12px;">SO/123</td>
                  </tr>
                  <tr style="height: 9px;">
                      <td style="width: 15.4549%; height: 9px; font-size: 12px;">Mode of Payment</td>
                      <td style="width: 24%; height: 9px; font-size: 12px;">Cash</td>
                  </tr>
                  <tr style="height: 15px;">
                      <td style="width: 15.4549%; height: 15px; font-size: 12px;">Transport</td>
                      <td style="width: 24%; height: 15px; font-size: 12px;">ABT Lorry</td>
                  </tr>
              </tbody>
          </table>
          <p>&nbsp;</p>
          <table style="width: 100%;" border="1" cellspacing="0" cellpadding="0">
              <tbody>
                  <tr style="height: 28px;">
                      <th style="width: 3%; height: 28px;">S.No</th>
                      <th style="width: 20%; height: 28px;">Particulars</th>
                      <th style="width: 5%; height: 28px;">HSN Code</th>
                      <th style="width: 7%; height: 28px;">QTY</th>
                      <th style="width: 12%; height: 28px;">Price<br />(Rs.)</th>
                      <th style="width: 15%; height: 28px;">Taxable Value<br />(Rs.)</th>
                      <th style="width: 10%; height: 28px;">CGST<br />(Rs.)</th>
                      <th style="width: 10%; height: 28px;">SGST<br />(Rs.)</th>
                      <th style="width: 8%; height: 28px;">CESS<br />(Rs.)</th>
                      <th style="width: 10%; height: 28px;">Total<br />(Rs.)</th>
                  </tr>
                  <tr style="height: 13px;">
                      <td style="width: 3%; height: 13px; font-size: 14px;">&nbsp;</td>
                      <td style="width: 20%; height: 13px; font-size: 14px;">&nbsp;Apple iPhone 10</td>
                      <td style="width: 5%; height: 13px; text-align: center; font-size: 14px;">XBV</td>
                      <td style="width: 7%; height: 13px; text-align: center; font-size: 14px;">12 unit</td>
                      <td style="width: 12%; height: 13px; text-align: center; font-size: 14px;">&nbsp;Rs. 1000</td>
                      <td style="width: 15%; height: 13px; text-align: center; font-size: 14px;">Rs. 12000</td>
                      <td style="width: 10%; height: 13px; text-align: center; font-size: 14px;">&nbsp;Rs. 600<br />@5%</td>
                      <td style="width: 10%; height: 13px; text-align: center; font-size: 14px;">&nbsp;Rs. 600<br />@5%</td>
                      <td style="width: 8%; height: 13px; text-align: center; font-size: 14px;">&nbsp;Rs. 120<br />@1%</td>
                      <td style="width: 10%; height: 13px; text-align: center; font-size: 14px;">Rs. 13320&nbsp;</td>
                  </tr>
                  <tr style="height: 13px;">
                      <td style="width: 3%; height: 13px; font-size: 14px;">&nbsp;</td>
                      <td style="width: 20%; height: 13px; font-size: 14px;">&nbsp;Samsung S20</td>
                      <td style="width: 5%; height: 13px; text-align: center; font-size: 14px;">KIV</td>
                      <td style="width: 7%; height: 13px; text-align: center; font-size: 14px;">10 Pcs&nbsp;</td>
                      <td style="width: 12%; height: 13px; text-align: center; font-size: 14px;">Rs. 500</td>
                      <td style="width: 15%; height: 13px; text-align: center; font-size: 14px;">Rs. 5000</td>
                      <td style="width: 10%; height: 13px; text-align: center; font-size: 14px;">Rs. 250<br />@5%</td>
                      <td style="width: 10%; height: 13px; text-align: center; font-size: 14px;">Rs. 250<br />@5%</td>
                      <td style="width: 8%; height: 13px; text-align: center; font-size: 14px;">Rs. 50<br />@1%</td>
                      <td style="width: 10%; height: 13px; text-align: center; font-size: 14px;">Rs. 5550&nbsp;</td>
                  </tr>
                  <tr style="height: 13px;">
                      <td style="width: 3%; height: 13px; font-size: 14px;">&nbsp;</td>
                      <td style="width: 20%; height: 13px; font-size: 14px;">TOTAL</td>
                      <td style="width: 5%; height: 13px; text-align: center; font-size: 14px;">&nbsp;</td>
                      <td style="width: 7%; height: 13px; text-align: center; font-size: 14px;">&nbsp;</td>
                      <td style="width: 12%; height: 13px; text-align: center; font-size: 14px;">&nbsp;</td>
                      <td style="width: 15%; height: 13px; text-align: center; font-size: 14px;">&nbsp;Rs. 17000</td>
                      <td style="width: 10%; height: 13px; text-align: center; font-size: 14px;">Rs. 850</td>
                      <td style="width: 10%; height: 13px; text-align: center; font-size: 14px;">Rs. 850</td>
                      <td style="width: 8%; height: 13px; text-align: center; font-size: 14px;">Rs. 170</td>
                      <td style="width: 10%; height: 13px; text-align: center; font-size: 14px;">Rs. 18870</td>
                  </tr>
              </tbody>
          </table>
          <p>&nbsp;</p>
          <table style="width: 405px; height: 53px; float: right;" border="0" cellspacing="0" cellpadding="0">
              <tbody>
                  <tr style="height: 12px;">
                      <td style="height: 12px; width: 401px;">
                          <b>Total Taxable Value</b>
                      </td>
                      <td style="height: 12px; width: 401px;">
                          <b>: Rs. 17000</b>
                      </td>
                  </tr>
                  <tr style="height: 13px;">
                      <td style="height: 13px; width: 401px;">
                          <b>Total Tax Value</b>
                      </td>
                      <td style="height: 13px; width: 401px;">
                          <b>: Rs. 1870</b>
                      </td>
                  </tr>
                  <tr style="height: 13px;">
                      <td style="height: 13px; width: 401px;">
                          <b>Total Invoice Value</b>
                      </td>
                      <td style="height: 13px; width: 401px;">
                          <b>: Rs. 18870</b>
                      </td>
                  </tr>
              </tbody>
          </table>
          <p style="text-align: right;">For Company name</p>
          <br><br><br>
          <p style="text-align: right;">Authorized Signatory</p>
          `, {
          defaultStyles:defaultStyle
        });
        var styles='';
        var filename='test';
        var pdfType=4;
        var windowType=1;
        var docDefinition = {
          content: content,
          styles: styles,
          defaultStyle: defaultStyle
        };
        this.generatePDF(filename, pdfType, windowType, docDefinition);
      }
    },    

    deleteAlert(tr) {

      console.log('tr='+tr);
      var n = Object.keys(tr).length;
      console.log('n='+n);
      if (n > 0) {

        var id=tr.PurchaseInvoiceId;
        var details=tr.PartyName;
        console.log('id='+id+', details'+details);

        var alert_title='Delete Purchase Invoice details';
        var alert_text='Do you want to delete '+details+' Purchase Invoice details?';

        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: alert_title,
          text: alert_text,
          accept: this.deleteData
        });
        // this.deleteRecords(where, url, destination, list_url);
        
      } else {
        var output = 'Kindly select record to delete';
        this.errorMessage(output);
      }
      
    },
      
    deleteData(){
      var selected = this.selected;
      var n = Object.keys(selected).length;
      var id1=selected.PurchaseInvoiceId;
      var id2=selected.TransactionDetailsId;
      console.log('n='+n+', id1='+id1+', id2='+id2);

      var server_url=companyConfig.apiURL;
      this.record.token=this.$session.get('token');
      this.record.delete_url=server_url+'lib/api/purchase/purchase/delete';
      this.record.where={
        "purchase_invoice_id": id1,
        "purchase_invoice_transaction_details_id": id2,        
      };
      this.record.list_url=server_url+'lib/api/purchase/purchase/lists';
      this.record.list_where={
      };
      console.log('deleteData record='+JSON.stringify(this.record));
      this.record.loading=this.$vs.loading;
      this.record.notify=this.$vs.notify;
      this.record.http=this.$http;      
      this.$store.dispatch('purchase/deleteRecordDetails', this.record);     
    },

  },
  beforeCreate: function () {    
    if (!this.$session.exists()) {
      console.log('your session is expired');
      this.$router.push('/');
    }    
  },
  beforeMount() {    
    if (!this.$session.exists()) {
      console.log('your session is expired');
      this.$router.push('/');      
    }else{

      var server_url=companyConfig.apiURL;
      var role=this.$session.get('role');
      console.log('server_url='+server_url+', role='+role);
      if (role != "") {
        this.btnActions.push(
          {
              name: 'addbtn',
              icon: 'add',
              tooltip: 'Add',
              color: '#28c76f'
          },
          /*
          {
              name: 'editbtn',
              icon: 'edit',
              tooltip: 'Edit',
              color: '#7367f0'
          },
          */
          {
              name: 'pdfbtn',
              icon: 'print',
              tooltip: 'Print',
              color: '#000000'
          },       
          {
              name: 'viewbtn',
              icon: 'search',
              tooltip: 'View',
              color: '#ff9f43'
          },
          {
              name: 'deletebtn',
              icon: 'delete',
              tooltip: 'Delete',
              color: '#ea5455'
          },      
        );
      }

      this.getAllRecords.token=this.$session.get('token');
      this.getAllRecords.list_url=server_url+'lib/api/purchase/purchase/lists';
      this.getAllRecords.list_where={};
      console.log('beforeMount getAllRecords='+JSON.stringify(this.getAllRecords));
      this.getAllRecords.loading=this.$vs.loading;
      this.getAllRecords.notify=this.$vs.notify;
      this.getAllRecords.http=this.$http;    
      this.$store.dispatch('purchase/loadAllRecords', this.getAllRecords);
    }
  },
  mounted() {
    this.pageLoadingOff();
    this.isMounted = true;    
  }
}
</script>

<style lang="scss">

#data-list-list-view {
  .vs-con-table {

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 .3rem;
      // padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            // padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            // padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

#printPdf {
  position: fixed;
  top: 0px;
  left: 0px;
  display: block;
  padding: 0px;
  border: 0px;
  margin: 0px;
  visibility: hidden;
  opacity: 0;
}

</style>
